import React from "react"

import Header from "../components/Header"
import Navigation from "../components/Navigation"
import Users from "../components/admin/Users"

function AdminPage() {
  return (
    <>
      <Header />
      <div className="page-with-nav">
        <Navigation />
        <Users />
      </div>
    </>
  )
}

export default AdminPage
